module.exports = __webpack_public_path__ + "static/media/signature.cc31d82e.png";